import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

const variants = {
  primary:  'bg-brand-600 text-white hover:bg-brand-700 active:bg-brand-800 shadow-sm hover:shadow disabled:bg-brand-300 dark:disabled:bg-brand-900/50',
  secondary:'bg-white text-ink-900 border border-ink-200 hover:bg-ink-50 hover:border-ink-300 active:bg-ink-100 disabled:text-ink-400 disabled:bg-ink-50 dark:bg-ink-800 dark:text-ink-100 dark:border-ink-700 dark:hover:bg-ink-700 dark:hover:border-ink-600',
  ghost:    'bg-transparent text-ink-700 hover:bg-ink-100 hover:text-ink-900 active:bg-ink-200 disabled:text-ink-400 dark:text-ink-300 dark:hover:bg-ink-800 dark:hover:text-ink-100',
  danger:   'bg-danger text-white hover:bg-danger-dark active:bg-danger-dark shadow-sm disabled:bg-danger/50',
  success:  'bg-success text-white hover:bg-success-dark active:bg-success-dark shadow-sm disabled:bg-success/50',
  outline:  'bg-transparent text-brand-700 border border-brand-200 hover:bg-brand-50 hover:border-brand-300 active:bg-brand-100 dark:text-brand-300 dark:border-brand-800 dark:hover:bg-brand-900/30',
};

const sizes = {
  xs:  'h-7  px-2.5 text-xs    gap-1.5  rounded-sm',
  sm:  'h-8  px-3   text-sm    gap-1.5  rounded',
  md:  'h-10 px-4   text-sm    gap-2    rounded-md',
  lg:  'h-11 px-5   text-[15px] gap-2   rounded-md',
  xl:  'h-12 px-6   text-base  gap-2.5  rounded-lg',
  icon:'h-9  w-9              gap-0    rounded-md',
};

const Button = forwardRef(function Button({
  className,
  variant = 'primary',
  size = 'md',
  loading = false,
  leftIcon,
  rightIcon,
  children,
  disabled,
  type = 'button',
  ...props
}, ref) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={cn(
        'inline-flex items-center justify-center font-semibold tracking-tightish',
        'transition-all duration-150 ease-out',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:shadow-none',
        variants[variant],
        sizes[size],
        loading && 'cursor-wait',
        className,
      )}
      {...props}
    >
      {loading ? (
        <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="3" opacity="0.25"/>
          <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      ) : leftIcon}
      {children}
      {!loading && rightIcon}
    </button>
  );
});

export default Button;
